'use strict';

var sliders = require('../common/sliders');
var swatchSelector = require('../components/swatchSelector');

// Event delegation for click tracking.
// Covers both server-rendered tiles (mock/edit mode) and async-loaded tiles.
$(document).on('click', '.js-einstein-item', function () {
    var $item = $(this);
    var isEinstein = Boolean($item.attr('data-is-einstein'));
    if (isEinstein) {
        var productTileID = $item.attr('data-pid');
        var url = $item.attr('data-trackactivity-url');
        var recoType = $item.attr('data-reco-type');
        if (productTileID && recoType && url) {
            $.ajax({
                url: url + '?pid=' + productTileID + '&recoType=' + recoType,
                method: 'POST',
                error: function () {}
            });
        }
    }
});

/**
 * Fetch and inject a single Einstein carousel.
 * Called either immediately (IntersectionObserver polyfill path) or
 * when the carousel enters the viewport + 200px rootMargin.
 */
function loadCarousel($slider) {
    var url = $slider.data('loadUrl');
    if (!url) return;

    // Resolve the container to hide when the carousel has no products.
    // Priority: .cc-section-slider (Section_Slider wrapper, includes the title)
    // Fallback: .cc-product-slider (standalone Product_slider usage).
    // Cannot use closest('.cc-section-slider, .cc-product-slider') because jQuery
    // stops at the nearest match — .cc-product-slider is always closer.
    var $sectionToHide = $slider.closest('.cc-section-slider');
    if (!$sectionToHide.length) {
        $sectionToHide = $slider.closest('.cc-product-slider');
    }

    $slider.addClass('is-loading').attr('aria-busy', 'true');

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html',
        data: {
            carouselType: $slider.data('carouselType'),
            maxProduct: $slider.data('maxProduct'),
            pageProductMasterID: $slider.data('productMasterId'),
            categoryId: $slider.data('categoryId'),
            productContextId: $slider.data('productContextId'),
            productVariationGroupId: $slider.data('productVariationGroupId')
        },
        success: function (html) {
            var $parsed = $(html);
            var $tiles = $parsed.filter('.js-einstein-item');

            if (!$tiles.length) {
                $sectionToHide.remove();
                return;
            }

            var $ga4 = $parsed.filter('.viewItemListData');

            // Destroy Slick before replacing content:
            // sliders.js initializes Slick on .js-slider at page load (skeleton included),
            // so we must unslick first — otherwise initializeSliders() skips reinit.
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            // Replace skeleton tiles with real product tiles
            $slider.html($tiles);

            // Append GA4 data block after the slider, inside __extra-wrp
            if ($ga4.length) {
                $slider.after($ga4);
            }

            $slider.removeClass('is-loading').addClass('is-loaded').attr('aria-busy', 'false');

            // Defer Slick init to a new macrotask so the AJAX success handler
            // completes first, avoiding a long task collision with user interactions.
            setTimeout(function () {
                sliders.initializeSliders($slider);
                swatchSelector.initializeClass($slider);
                $(document).trigger('einstein:loaded', [$slider]);
            }, 0);
        },
        error: function () {
            $slider.removeClass('is-loading').addClass('is-error').attr('aria-busy', 'false');
            $sectionToHide.remove();
        }
    });
}

// Async carousel loading: trigger fetch as each carousel approaches the viewport.
// IntersectionObserver with rootMargin 400px preloads carousels before
// they become visible, avoiding the burst of 6 parallel fetches on DOMContentLoaded
// that would inflate TBT and Speed Index.
$(() => {
    var $loaders = $('.js-einstein-carousel-loader');
    if (!$loaders.length) return;

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    loadCarousel($(entry.target));
                }
            });
        }, { rootMargin: '600px 0px' });

        $loaders.each(function () {
            observer.observe(this);
        });
    } else {
        // Fallback: fire all fetches immediately (old behaviour)
        $loaders.each(function () {
            loadCarousel($(this));
        });
    }
});
